import { AssignTripGroupingsToTripsInput } from '../../lib/types/models/trip/trip-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function assignTripGroupingsToTrips(data: AssignTripGroupingsToTripsInput) {
  return restApiClient
    .url(constructApiUrl(API.trips.assignTripGroupingsToTrips.url, null))
    .post<unknown, AssignTripGroupingsToTripsInput>(data)
}
